import { Button, Drawer, Form, message, Tabs } from "antd";
import { useForm } from "antd/lib/form/Form";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ICmsItem } from "../../../api/dto/cms/ICmsItem";
import { deepMerge } from "../../../common/helpers/deepMerge";
import { useAppDispatch } from "../../../core/redux/store";
import { getAllCmsDataThunk, publishCmsDataThunk } from "../../../modules/cms/cmsActionAsync";
import { ShowCloseModal } from "../../../ui/ShowCloseModal";
import { FormPlayerOfMatch } from "../form/FormPlayerOfMatch";
import { FormPlayerOfMonthAndSeason } from "../form/FormPlayerOfMonthAndSeason";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  cmsItem?: ICmsItem;
  searchName: string;
}

export const SectionForm = ({ isOpen, onClose, cmsItem, searchName }: IProps) => {
  const { t } = useTranslation();
  const [form] = useForm();
  const [lang, setLang] = useState("Ru");
  const [values, setValues] = useState<any>();
  const [isFormChanged, setIsFormChanged] = useState(false);

  const dispatch = useAppDispatch();

  const handleTabClick = (key: string) => {
    setValues(form.getFieldsValue());
    setLang(key);
  };

  useEffect(() => {
    if (isOpen && cmsItem) {
      const initialData = JSON.parse(cmsItem?.jsonData);

      form.setFieldsValue(initialData);
      setValues(initialData);
      console.log(form.getFieldsValue());
    }
  }, [cmsItem, isOpen]);

  const closeFormHandle = () => {
    onClose();
    setValues(undefined);
    setIsFormChanged(false);
    form.resetFields();
  };

  const submitForm = () => {
    const newValue = deepMerge<any>({ ...values }, form.getFieldsValue());
    if (cmsItem) {
      dispatch(publishCmsDataThunk({ jsonData: JSON.stringify(newValue), title: cmsItem?.title, link: "/", type: cmsItem?.type }))
        .unwrap()
        .then(() => {
          onClose();
          message.success("Изменения сохранены.");
          dispatch(getAllCmsDataThunk(searchName));
        })
        .catch((error: any) => console.error("Ошибка при сохранении:", error));
    }
  };

  const sectionForm = useCallback(() => {
    switch (cmsItem?.type) {
      case "playerOfMatch":
        return <FormPlayerOfMatch form={form} lang={lang} />;
      case "playerOfMonth":
      case "playerOfSeason":
        return <FormPlayerOfMonthAndSeason form={form} lang={lang} />;

      default: {
        console.log("нет такой схемы =>", cmsItem?.type);

        return null;
      }
    }
  }, [cmsItem, lang, values, form]);

  return (
    <Drawer
      open={isOpen}
      onClose={isFormChanged ? ShowCloseModal(closeFormHandle, t) : closeFormHandle}
      width={800}
      closable={false}
      title={cmsItem?.title}
      footer={
        <div
          style={{
            textAlign: "right"
          }}
        >
          <Button onClick={isFormChanged ? ShowCloseModal(closeFormHandle, t) : closeFormHandle} style={{ marginRight: 8 }}>
            {t("common.buttonsText.cancel")}
          </Button>
          <Button onClick={submitForm} type="primary" htmlType={"submit"}>
            {t("common.buttonsText.save")}
          </Button>
        </div>
      }
    >
      <Tabs defaultActiveKey={lang} onChange={handleTabClick}>
        <Tabs.TabPane tab="Русский язык" key="Ru" />
        <Tabs.TabPane tab="Английский язык" key="En" />
      </Tabs>
      <Form form={form} onValuesChange={() => setIsFormChanged(true)}>
        {sectionForm()}
      </Form>
    </Drawer>
  );
};
